
import {
  ContractSaleStatus,
  FleetVehicleContractSale,
  FleetVehicleContractSaleEditFormValues,
  FleetVehicleContractSaleRow,
  ContractRentStatus,
  FleetVehicleContractRent,
  FleetVehicleContractRentEditFormValues,
  FleetVehicleContractRentRow,
} from "./types";

export const transformFleetVehicleContractSaleRow = (
  res: any
): FleetVehicleContractSaleRow => {
  return {
    id: res.id,
    contractNumber: res.contractNumber,
    contractDate: res.contractDate,
    offerSale: res.offerSale,
    vehicle: res.vehicle ?? null,
    contactClient: res.contactClient ?? res.offerSale?.contactClient ?? null,
    sellerCompanyName: res.sellerCompanyName,
    sellerHeadquartersAddress: res.sellerHeadquartersAddress,
    sellerPhoneNumber: res.sellerPhoneNumber,
    sellerPersonalIdentificationNumber: res.sellerPersonalIdentificationNumber,
    sellerSalesPersonName: res.sellerSalesPersonName,
    sellerTransactionAccountNumber: res.sellerTransactionAccountNumber,
    buyerContactId: res.buyerContactId ?? null,
    buyerContactTypeId: res.buyerContactTypeId ?? null,
    buyerName: res.buyerName,
    buyerAddress: res.buyerAddress,
    buyerPersonalIdentificationNumber: res.buyerPersonalIdentificationNumber,
    buyerPhoneNumber: res.buyerPhoneNumber,
    buyerMobilePhoneNumber: res.buyerMobilePhoneNumber,
    buyerEmail: res.buyerEmail,
    buyerAuthorizedRepresentativeName: res.buyerAuthorizedRepresentativeName,
    depositAmount: res.depositAmount,
    deliveryTime: res.deliveryTime,
    contractSaleTemplateId: res.contractSaleTemplateId,
    netPrice: res.netPrice,
    sellingPrice: res.sellingPrice,
    placeOfVehicleDelivery: res.placeOfVehicleDelivery,
    createdOn: res.createdOn,
    status: res.status ?? null,
    userCreatedName: res.userCreatedName ?? null,
    pdfUpload: res.pdfUpload ?? null,
  };
};


export const transformFleetVehicleContractSaleOnCreate = (
  formValues: FleetVehicleContractSaleEditFormValues,
  vehicleId: string
): any => ({

  contractNumber: formValues.contractNumber,
  contractDate: formValues.contractDate,
  offerSaleId: formValues.offerSaleId,

  // Seller
  sellerCompanyName: formValues.sellerCompanyName,
  sellerHeadquartersAddress: formValues.sellerHeadquartersAddress,
  sellerPhoneNumber: formValues.sellerPhoneNumber,
  sellerPersonalIdentificationNumber:
    formValues.sellerPersonalIdentificationNumber,
  sellerSalesPersonName: formValues.sellerSalesPersonName,
  sellerTransactionAccountNumber:
    formValues.sellerTransactionAccountNumber,

  // Buyer
  buyerContactId: formValues.buyerContactId,
  buyerName: formValues.buyerName,
  buyerAddress: formValues.buyerAddress,
  buyerPersonalIdentificationNumber:
    formValues.buyerPersonalIdentificationNumber,
  buyerPhoneNumber: formValues.buyerPhoneNumber,
  buyerMobilePhoneNumber: formValues.buyerMobilePhoneNumber,
  buyerEmail: formValues.buyerEmail,
  buyerAuthorizedRepresentativeName:
    formValues.buyerAuthorizedRepresentativeName,

  // Contract details
  depositAmount: formValues.depositAmount,
  deliveryTime: formValues.deliveryTime,
  placeOfVehicleDelivery: formValues.placeOfVehicleDelivery,

  tradeInVehicleId: formValues.tradeInVehicleId,

  contractSaleTemplateId: formValues.contractSaleTemplateId,


  // Vehicle reference
  vehicleId,

});

export const transformFleetVehicleContractSaleOnUpdate = (
  formValues: FleetVehicleContractSaleEditFormValues,
  vehicleId: string
): any => ({
  id: formValues.id,
  // contractNumber: formValues.contractNumber,
  contractDate: formValues.contractDate,
  // offerSaleId: formValues.offerSaleId,

  // Seller
  sellerCompanyName: formValues.sellerCompanyName,
  sellerHeadquartersAddress: formValues.sellerHeadquartersAddress,
  sellerPhoneNumber: formValues.sellerPhoneNumber,
  sellerPersonalIdentificationNumber:
    formValues.sellerPersonalIdentificationNumber,
  sellerSalesPersonName: formValues.sellerSalesPersonName,
  sellerTransactionAccountNumber:
    formValues.sellerTransactionAccountNumber,

  // Buyer
  buyerContactId: formValues.buyerContactId,
  buyerName: formValues.buyerName,
  buyerAddress: formValues.buyerAddress,
  buyerPersonalIdentificationNumber:
    formValues.buyerPersonalIdentificationNumber,
  buyerPhoneNumber: formValues.buyerPhoneNumber,
  buyerMobilePhoneNumber: formValues.buyerMobilePhoneNumber,
  buyerEmail: formValues.buyerEmail,
  buyerAuthorizedRepresentativeName:
    formValues.buyerAuthorizedRepresentativeName,

  // Contract details
  depositAmount: formValues.depositAmount,
  deliveryTime: formValues.deliveryTime,
  placeOfVehicleDelivery: formValues.placeOfVehicleDelivery,

  tradeInVehicleId: formValues.tradeInVehicleId,

  contractSaleTemplateId: formValues.contractSaleTemplateId,
  contractSaleStatusId: formValues.contractSaleStatusId,

  // Vehicle reference
  vehicleId,
});

export const transformFleetVehicleContractSale = (
  res: any
): FleetVehicleContractSale => {
  return {
    id: res.id,
    vehicleId: res.vehicleId,
    contractNumber: res.contractNumber,
    contractDate: res.contractDate,
    offerSale: res.offerSale,
    sellerCompanyName: res.sellerCompanyName,
    sellerHeadquartersAddress: res.sellerHeadquartersAddress,
    sellerPhoneNumber: res.sellerPhoneNumber,
    sellerPersonalIdentificationNumber: res.sellerPersonalIdentificationNumber,
    sellerSalesPersonName: res.sellerSalesPersonName,
    sellerTransactionAccountNumber: res.sellerTransactionAccountNumber,
    buyerContactId: res.buyerContactId ?? null,
    buyerContactTypeId: res.buyerContactTypeId ?? null,
    buyerName: res.buyerName,
    buyerAddress: res.buyerAddress,
    buyerPersonalIdentificationNumber: res.buyerPersonalIdentificationNumber,
    buyerPhoneNumber: res.buyerPhoneNumber,
    buyerMobilePhoneNumber: res.buyerMobilePhoneNumber,
    buyerEmail: res.buyerEmail,
    buyerAuthorizedRepresentativeName: res.buyerAuthorizedRepresentativeName,
    depositAmount: res.depositAmount,
    deliveryTime: res.deliveryTime,
    netPrice: res.netPrice,
    sellingPrice: res.sellingPrice,
    placeOfVehicleDelivery: res.placeOfVehicleDelivery,
    tradeInVehicle: res.tradeInVehicle,
    contractSaleTemplate: res.contractSaleTemplate,
    createdOn: res.createdOn,
    status: res.status ?? null,
    statusHistory: res.statusHistory ?? [],
    pdfUpload: res.pdfUpload ?? null,
  };
};


export const transformFleetVehicleContractSaleEditForm = (
  res: FleetVehicleContractSale
): FleetVehicleContractSaleEditFormValues => ({
  id: res.id,
    vehicleId: res.vehicleId,
    contractNumber: res.contractNumber,
    contractDate: res.contractDate,
    offerSaleId: res.offerSale?.id,
    sellerCompanyName: res.sellerCompanyName,
    sellerHeadquartersAddress: res.sellerHeadquartersAddress,
    sellerPhoneNumber: res.sellerPhoneNumber,
    sellerPersonalIdentificationNumber: res.sellerPersonalIdentificationNumber,
    sellerSalesPersonName: res.sellerSalesPersonName,
    sellerTransactionAccountNumber: res.sellerTransactionAccountNumber,
    buyerContactId: res.buyerContactId ?? res.offerSale?.contactClient?.id ?? "",
    buyerContactTypeId: res.buyerContactTypeId ?? null,
    buyerName: res.buyerName,
    buyerAddress: res.buyerAddress,
    buyerPersonalIdentificationNumber: res.buyerPersonalIdentificationNumber,
    buyerPhoneNumber: res.buyerPhoneNumber,
    buyerMobilePhoneNumber: res.buyerMobilePhoneNumber,
    buyerEmail:  res.buyerEmail,
    buyerAuthorizedRepresentativeName: res.buyerAuthorizedRepresentativeName,
    depositAmount: res.depositAmount,
    deliveryTime: res.deliveryTime,
    placeOfVehicleDelivery: res.placeOfVehicleDelivery,
    tradeInVehicleId: res.tradeInVehicle?.id,
    contractSaleTemplateId: res.contractSaleTemplate?.id ?? null,
    contractSaleStatusId: res.status?.id ?? null,
    createdOn:res.createdOn,
});


/*-------------------------------------------------------------------------------------------
  CONTRACT RENT TRANSFORMATIONS
---------------------------------------------------------------------------------------------*/

export const transformContractSaleStatus = (res: any): ContractSaleStatus => ({
  id: res.id,
  name: res.name,
  color: res.color,
});

export const transformContractRentStatus = (res: any): ContractRentStatus => ({
  id: res.id,
  name: res.name,
  color: res.color,
});

export const transformFleetVehicleContractRentRow = (
  res: any
): FleetVehicleContractRentRow => {
  return {
    id: res.id,
    contractNumber: res.contractNumber,
    contractDate: res.contractDate,
    offerRent: res.offerRent,
    vehicle: res.vehicle ?? null,
    contactClient: res.contactClient ?? res.offerRent?.contactClient ?? null,
    lessorCompanyName: res.lessorCompanyName,
    lessorHeadquartersAddress: res.lessorHeadquartersAddress,
    lessorPhoneNumber: res.lessorPhoneNumber,
    lessorPersonalIdentificationNumber: res.lessorPersonalIdentificationNumber,
    lessorSalesPersonName: res.lessorSalesPersonName,
    lessorTransactionAccountNumber: res.lessorTransactionAccountNumber,
    lesseeContactId: res.lesseeContactId ?? null,
    lesseeContactTypeId: res.lesseeContactTypeId ?? null,
    lesseeName: res.lesseeName,
    lesseeAddress: res.lesseeAddress,
    lesseePersonalIdentificationNumber: res.lesseePersonalIdentificationNumber,
    lesseePhoneNumber: res.lesseePhoneNumber,
    lesseeMobilePhoneNumber: res.lesseeMobilePhoneNumber,
    lesseeEmail: res.lesseeEmail,
    lesseeAuthorizedRepresentativeName: res.lesseeAuthorizedRepresentativeName,
    depositAmount: res.depositAmount,
    deliveryTime: res.deliveryTime,
    rentStartDate: res.rentStartDate,
    rentEndDate: res.rentEndDate,
    rentDurationMonths: res.rentDurationMonths,
    monthlyPrice: res.monthlyPrice,
    contractRentTemplateId: res.contractRentTemplateId,
    netPrice: res.netPrice,
    sellingPrice: res.sellingPrice,
    placeOfVehicleDelivery: res.placeOfVehicleDelivery,
    createdOn: res.createdOn,
    status: res.status ?? null,
    userCreatedName: res.userCreatedName ?? null,
    pdfUpload: res.pdfUpload ?? null,
  };
};

export const transformFleetVehicleContractRent = (
  res: any
): FleetVehicleContractRent => {
  return {
    id: res.id,
    vehicleId: res.vehicleId,
    contractNumber: res.contractNumber,
    contractDate: res.contractDate,
    offerRent: res.offerRent,
    lessorCompanyName: res.lessorCompanyName,
    lessorHeadquartersAddress: res.lessorHeadquartersAddress,
    lessorPhoneNumber: res.lessorPhoneNumber,
    lessorPersonalIdentificationNumber: res.lessorPersonalIdentificationNumber,
    lessorSalesPersonName: res.lessorSalesPersonName,
    lessorTransactionAccountNumber: res.lessorTransactionAccountNumber,
    lesseeContactId: res.lesseeContactId ?? null,
    lesseeContactTypeId: res.lesseeContactTypeId ?? null,
    lesseeName: res.lesseeName,
    lesseeAddress: res.lesseeAddress,
    lesseePersonalIdentificationNumber: res.lesseePersonalIdentificationNumber,
    lesseePhoneNumber: res.lesseePhoneNumber,
    lesseeMobilePhoneNumber: res.lesseeMobilePhoneNumber,
    lesseeEmail: res.lesseeEmail,
    lesseeAuthorizedRepresentativeName: res.lesseeAuthorizedRepresentativeName,
    depositAmount: res.depositAmount,
    deliveryTime: res.deliveryTime,
    rentStartDate: res.rentStartDate,
    rentEndDate: res.rentEndDate,
    rentDurationMonths: res.rentDurationMonths,
    monthlyPrice: res.monthlyPrice,
    netPrice: res.netPrice,
    sellingPrice: res.sellingPrice,
    placeOfVehicleDelivery: res.placeOfVehicleDelivery,
    contractRentTemplate: res.contractRentTemplate,
    createdOn: res.createdOn,
    status: res.status ?? null,
    statusHistory: res.statusHistory ?? [],
    pdfUpload: res.pdfUpload ?? null,
  };
};

export const transformFleetVehicleContractRentEditForm = (
  res: FleetVehicleContractRent
): FleetVehicleContractRentEditFormValues => ({
  id: res.id,
    vehicleId: res.vehicleId,
    contractNumber: res.contractNumber,
    contractDate: res.contractDate,
    offerRentId: res.offerRent?.id,
    lessorCompanyName: res.lessorCompanyName,
    lessorHeadquartersAddress: res.lessorHeadquartersAddress,
    lessorPhoneNumber: res.lessorPhoneNumber,
    lessorPersonalIdentificationNumber: res.lessorPersonalIdentificationNumber,
    lessorSalesPersonName: res.lessorSalesPersonName,
    lessorTransactionAccountNumber: res.lessorTransactionAccountNumber,
    lesseeContactId: res.lesseeContactId ?? res.offerRent?.contactClient?.id ?? "",
    lesseeContactTypeId: res.lesseeContactTypeId ?? null,
    lesseeName: res.lesseeName,
    lesseeAddress: res.lesseeAddress,
    lesseePersonalIdentificationNumber: res.lesseePersonalIdentificationNumber,
    lesseePhoneNumber: res.lesseePhoneNumber,
    lesseeMobilePhoneNumber: res.lesseeMobilePhoneNumber,
    lesseeEmail: res.lesseeEmail,
    lesseeAuthorizedRepresentativeName: res.lesseeAuthorizedRepresentativeName,
    depositAmount: res.depositAmount,
    deliveryTime: res.deliveryTime,
    rentStartDate: res.rentStartDate,
    rentEndDate: res.rentEndDate,
    rentDurationMonths: res.rentDurationMonths,
    monthlyPrice: res.monthlyPrice,
    placeOfVehicleDelivery: res.placeOfVehicleDelivery,
    contractRentTemplateId: res.contractRentTemplate?.id ?? null,
    contractRentStatusId: res.status?.id ?? null,
    createdOn: res.createdOn,
});

export const transformFleetVehicleContractRentOnCreate = (
  formValues: FleetVehicleContractRentEditFormValues,
  vehicleId: string
): any => ({

  contractNumber: formValues.contractNumber,
  contractDate: formValues.contractDate,
  offerRentId: formValues.offerRentId,

  // Lessor
  lessorCompanyName: formValues.lessorCompanyName,
  lessorHeadquartersAddress: formValues.lessorHeadquartersAddress,
  lessorPhoneNumber: formValues.lessorPhoneNumber,
  lessorPersonalIdentificationNumber:
    formValues.lessorPersonalIdentificationNumber,
  lessorSalesPersonName: formValues.lessorSalesPersonName,
  lessorTransactionAccountNumber:
    formValues.lessorTransactionAccountNumber,

  // Lessee
  lesseeContactId: formValues.lesseeContactId,
  lesseeName: formValues.lesseeName,
  lesseeAddress: formValues.lesseeAddress,
  lesseePersonalIdentificationNumber:
    formValues.lesseePersonalIdentificationNumber,
  lesseePhoneNumber: formValues.lesseePhoneNumber,
  lesseeMobilePhoneNumber: formValues.lesseeMobilePhoneNumber,
  lesseeEmail: formValues.lesseeEmail,
  lesseeAuthorizedRepresentativeName:
    formValues.lesseeAuthorizedRepresentativeName,

  // Contract details
  depositAmount: formValues.depositAmount,
  deliveryTime: formValues.deliveryTime,
  placeOfVehicleDelivery: formValues.placeOfVehicleDelivery,

  // Rental-specific
  rentStartDate: formValues.rentStartDate,
  rentEndDate: formValues.rentEndDate,
  rentDurationMonths: formValues.rentDurationMonths,
  monthlyPrice: formValues.monthlyPrice,

  contractRentTemplateId: formValues.contractRentTemplateId,

  // Vehicle reference
  vehicleId,

});

export const transformFleetVehicleContractRentOnUpdate = (
  formValues: FleetVehicleContractRentEditFormValues,
  vehicleId: string
): any => ({
  id: formValues.id,
  contractDate: formValues.contractDate,

  // Lessor
  lessorCompanyName: formValues.lessorCompanyName,
  lessorHeadquartersAddress: formValues.lessorHeadquartersAddress,
  lessorPhoneNumber: formValues.lessorPhoneNumber,
  lessorPersonalIdentificationNumber:
    formValues.lessorPersonalIdentificationNumber,
  lessorSalesPersonName: formValues.lessorSalesPersonName,
  lessorTransactionAccountNumber:
    formValues.lessorTransactionAccountNumber,

  // Lessee
  lesseeContactId: formValues.lesseeContactId,
  lesseeName: formValues.lesseeName,
  lesseeAddress: formValues.lesseeAddress,
  lesseePersonalIdentificationNumber:
    formValues.lesseePersonalIdentificationNumber,
  lesseePhoneNumber: formValues.lesseePhoneNumber,
  lesseeMobilePhoneNumber: formValues.lesseeMobilePhoneNumber,
  lesseeEmail: formValues.lesseeEmail,
  lesseeAuthorizedRepresentativeName:
    formValues.lesseeAuthorizedRepresentativeName,

  // Contract details
  depositAmount: formValues.depositAmount,
  deliveryTime: formValues.deliveryTime,
  placeOfVehicleDelivery: formValues.placeOfVehicleDelivery,

  // Rental-specific
  rentStartDate: formValues.rentStartDate,
  rentEndDate: formValues.rentEndDate,
  rentDurationMonths: formValues.rentDurationMonths,
  monthlyPrice: formValues.monthlyPrice,

  contractRentTemplateId: formValues.contractRentTemplateId,
  contractRentStatusId: formValues.contractRentStatusId,

  // Vehicle reference
  vehicleId,
});
